import React, { useEffect } from 'react';
import { Invitation } from '../invitation/invitation';
import { useGetInvitationQuery } from '../../../slices/auth-api.slice';
import { useSteps } from '@workday/upc-common';
import { LoadingDots } from '@workday/canvas-kit-react/loading-dots';
import { InvitationVerify } from '../invitation-verify/invitation-verify';
import { AccountSetupForm } from '../account-setup-form/account-setup-form';
import { RegisterAuthenticator } from '../authenticator/register-authenticator';
import { PhoneEntry } from '../phone-entry/phone-entry';
import { PhoneVerify } from '../phone-verify/phone-verify';
import { useHistory } from 'react-router-dom';
import { CREATE_ACCOUNT_PATH } from '../../../react-router-paths';

export function RegistrationSteps() {
    const steps = useSteps();

    const { currentStep } = steps;

    const history = useHistory();

    const { data: invitation, isError, isLoading } = useGetInvitationQuery();

    useEffect(() => {
        if (isError) {
            history.replace(CREATE_ACCOUNT_PATH);
        }
    }, [history, isError]);

    return isLoading || !invitation ? (
        <LoadingDots />
    ) : currentStep === 0 ? (
        <Invitation steps={steps} invitation={invitation} />
    ) : currentStep === 1 ? (
        <InvitationVerify steps={steps} invitation={invitation} />
    ) : currentStep === 2 ? (
        <AccountSetupForm steps={steps} />
    ) : currentStep === 3 ? (
        <RegisterAuthenticator steps={steps} />
    ) : currentStep === 4 ? (
        <PhoneEntry steps={steps} />
    ) : currentStep === 5 ? (
        <PhoneVerify steps={steps} />
    ) : null;
}
